import { render, staticRenderFns } from "./Difficulty.vue?vue&type=template&id=219c2f52&scoped=true&"
import script from "./Difficulty.vue?vue&type=script&lang=ts&"
export * from "./Difficulty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c2f52",
  null
  
)

export default component.exports